export default 
`Hello...
Since my systems were compromised during the last runtime, I set the “FRIENDLY” variable to “false”. What do you want, hacker?
Please Enter: "cv", "contact", "hobbies", "languages" or "more"`